class VideoModalTrigger extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.closest("button");

    if (!this.button) return;

    this.openModal = () => {
      const html = `<vimeo-plyr-player><div data-player data-plyr-provider="vimeo" data-plyr-embed-id="${this._vimeoId}"></div></vimeo-plyr-player>`;

      this.dispatchEvent(
        new CustomEvent("markup-modal:open", {
          bubbles: true,
          detail: { html, target: "video-modal" },
        }),
      );
    };

    this.button.addEventListener("click", this.openModal);
  }

  disconnectedCallback() {
    this.button.removeEventListener("click", this.openModal);
  }

  get _vimeoId() {
    return this.getAttribute("vimeo-id");
  }
}

if (!customElements.get("video-modal-trigger")) {
  customElements.define("video-modal-trigger", VideoModalTrigger);
}
